import { ButtonBase, Paper, Typography, useMediaQuery } from "@mui/material";
import { ReactComponent as GoAppLogoSvg } from "assets/svgs/go-app-logo.svg";
import { ReactComponent as GoDriverLogoSvg } from "assets/svgs/go-driver-logo.svg";
import { ReactComponent as ArrowRightSvg } from "assets/svgs/arrow-right.svg";
import { DeviceDetectedEnum, MediaQueryBreakpointEnum } from "constants/Global";
import { EnvKeyEnum } from "constants/EnvConstants";

function AvailableForDownloadContent({ hideRider, hideDriver }) {
  const ismd = useMediaQuery(MediaQueryBreakpointEnum.md);

  const goRiderLink = DeviceDetectedEnum.IOS
    ? EnvKeyEnum.GO_RIDER_APPSTORE_LINK
    : EnvKeyEnum.GO_RIDER_PLAYSTORE_LINK;

  const goDriverLink = DeviceDetectedEnum.IOS
    ? EnvKeyEnum.GO_DRIVER_APPSTORE_LINK
    : EnvKeyEnum.GO_DRIVER_PLAYSTORE_LINK;

  return (
    <>
      <div className="flex flex-col md:flex-row gap-4 md:gap-8 mb-4">
        {[
          ...(hideRider
            ? []
            : [
                {
                  SvgIcon: GoAppLogoSvg,
                  to: goRiderLink,
                  title: "Go App",
                },
              ]),

          ...(hideDriver
            ? []
            : [
                {
                  SvgIcon: GoDriverLogoSvg,
                  to: goDriverLink,
                  title: "Go Driver App",
                },
              ]),
        ].map(({ SvgIcon, to, title }, index) => (
          <ButtonBase
            key={index}
            LinkComponent="a"
            href={to}
            target="_blank"
            className="block text-left flex-1"
          >
            <Paper className="p-4 flex flex-col rounded-2xl relative">
              <div className="flex items-center gap-4 flex-1">
                <SvgIcon
                  {...(ismd
                    ? { width: 100, height: 100 }
                    : { width: 50, height: 50 })}
                />
                <div>
                  <Typography variant="h6" className="font-bold">
                    Download the
                    <br />
                    {title}
                  </Typography>
                </div>
              </div>
              <div className="flex justify-end">
                <ArrowRightSvg width={32} height={32} />
              </div>
              <div className="bg-gray-900 absolute top-full h-2 left-0 right-0 rounded-b-2xl -translate-y-2" />
            </Paper>
          </ButtonBase>
        ))}
      </div>
    </>
  );
}

export default AvailableForDownloadContent;
